function setPrefixForLocalStorage() {
  const prefix = 'CommunityEMS_';

  // Store the original setItem method
  const originalSetItem = localStorage.setItem.bind(localStorage);

  // Create a wrapper
  localStorage.setItem = (key, value) => {
    const formattedKey = prefix + key;
    console.log(
      `設置 localStorage 元素（前綴：${prefix}）：${formattedKey}:${value}`,
    );

    // Call the original setItem method
    originalSetItem(formattedKey, value);
  };

  // Store the original setItem method
  const originalGetItem = localStorage.getItem.bind(localStorage);

  // Create a wrapper
  localStorage.getItem = (key) => {
    const formattedKey = prefix + key;
    console.log(`取得 localStorage 元素（前綴：${prefix}）：${formattedKey}`);

    // Call the original setItem method
    return originalGetItem(formattedKey);
  };

  const originalRemoveItem = localStorage.removeItem.bind(localStorage);

  localStorage.removeItem = (key) => {
    const formattedKey = prefix + key;
    return originalRemoveItem(formattedKey);
  };
}

export default setPrefixForLocalStorage;
